import React from 'react'

function CheckmarkCircle ({ className, fill, style }) {
  return (
    <svg fill={fill} className={className} style={style} width='20' height='20' viewBox='0 0 20 20'>
      <path d='M427,2034a10,10,0,1,0,10,10A10,10,0,0,0,427,2034Zm-1.875,15.039-3.516-4.18,1.289-1.289,2.226,2.188,6.445-5.625.9.9-7.344,8.008Z' transform='translate(-417 -2033.999)' />
    </svg>
  )
}

CheckmarkCircle.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor',
  style: null
}

export default CheckmarkCircle
